document.addEventListener("teeinblue-event-after-cart-added", function () {
  document.dispatchEvent(new CustomEvent("theme:cart:init"));
  setTimeout(() => {
    document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: !0 }));
    const cart = document.querySelector(".navlink.navlink--cart");
    cart.click();
  }, 2000);
});

// document.addEventListener("teeinblue-event-component-injected",function(){
//  const paragraphs = document.querySelectorAll('.tee-description__content p');
// paragraphs.forEach(paragraph => {
//     if (paragraph.innerHTML.trim() === '') {
//         paragraph.innerHTML = '<br/>';
//     }
// });
// })

// document.addEventListener("teeinblue-event-component-injected", function() {
//   if (document.body.hasAttribute('template-konfi_tib_poster_standard')) {
//   }
// })
window.onload = function () {
  const intervalId = setInterval(() => {
    const options = document.querySelectorAll(
      "#qikify-stickycart-v2-app .qsc2-product-item__option"
    );
    options.forEach((option) => {
      const optionName = option.querySelector(
        ".qsc2-product-item__option-name strong"
      );
      if (optionName) {
        if (optionName.textContent.includes("Available Product:")) {
          optionName.textContent = optionName.textContent.replace(
            "Available Product:",
            "Produkt:"
          );
          const optionValue = option.querySelector(
            ".qsc2-product-item__option-value"
          );
          // if (optionValue) { optionValue.remove() }
        } else if (optionName.textContent.includes("Size:")) {
          optionName.textContent = optionName.textContent.replace(
            "Size:",
            "Grösse:"
          );
        }
      }
    });
    if (options.length === 0) {
      clearInterval(intervalId);
    }
  }, 1000);
};
